import { Injectable, OnInit, Input, Inject, Directive } from '@angular/core';
import { ScheduledBucketDTO } from '../../services_autogenerated/generated_services';
import { DragAndDropService } from 'src/app/services/drag-and-drop.service';
import { AuthHelperService } from 'src/app/services/auth-helper.service';

@Directive()
@Injectable()
export abstract class BaseSchedulingViewComponent implements OnInit {
    public canEdit: boolean = false;

    constructor(
        private dragAndDropService: DragAndDropService,
        private authHelperService: AuthHelperService
    ) { }

    ngOnInit(): void {
        this.canEdit = this.authHelperService.getDecodedAccessToken().claimNames.includes('Be able to Schedule') || this.authHelperService.getDecodedAccessToken().claimNames.includes('Full Control');
        console.log(this.canEdit)
    }

    // The cards will emit an event that runs this
    generateWorkOrderLists(bucket: ScheduledBucketDTO): void {
        this.dragAndDropService.addBucketToCDKLists(bucket);
    }
}
